import config from '../../config/config';

import getRequest from './base/get';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Fetch the Accounts list with pagination
   */
  fetchUsers: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/facility/v1/charging-transaction/list-charging-transactions`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch the transaction list for export
   */
  fetchTransactionExport: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/facility/v1/facility/list-charging-transactions/export-data`,
      {
        ...parameters,
      },
    );
  },

  /**
   * Fetch approved station API
   * @returns
   */
  fetchListFilters: () => {
    return getRequest(`${config.reportApiUrl}api/facility/v1/charging-transaction/list-filters`);
  },
  /**
   * Fetch transaction by Id
   * @returns
   */
  fetchTransactionById: (id: string) => {
    return getRequest(
      `${config.reportApiUrl}api/facility/v1/charging-transaction/consumer-transaction-info/${id}`,
    );
  },
  /**
   * Fetch transaction by Id
   * @returns
   */
  fetchRevenuePayout: (query: QueryParameters = {}) => {
    const parameters = { ...query };
    return getRequest(`${config.transactionApiUrl}api/facility/v1/revenue-payout/`, {
      ...parameters,
    });
  },
  /**
   *  get for the Revenue Payout  Total
   */
  getRevenuePayoutAmount: (): Promise<any> => {
    return getRequest(
      `${config.transactionApiUrl}api/facility/v1/revenue-payout/transferred-total`,
    );
  },
  /**
   * Fetch Revenue getStripeHistoryExport API for export
   * @param query
   */
  getStripeHistoryExport: (query: QueryParameters = {}) => {
    const parameters = { ...query };
    return getRequest(`${config.transactionApiUrl}api/facility/v1/revenue-payout/export-data`, {
      ...parameters,
    });
  },
};
